import { rootEm } from '@plco-pro/styles/global'

export const remToPx = (rem: string) => {
  return parseFloat(rem.replace('rem', '')) * rootEm
}
